<script>
import AutoComplete from 'primevue/autocomplete';
import Checkbox from 'primevue/checkbox';

import CommonService from '../services/common';
import ConfigurationService from '../services/configuration';
import CommonConstants from '../common/Constants';


export default {
  components: {AutoComplete, Checkbox}, 
   data() {
    return {
      selectedItem: null,
      filteredData: [],
      data: [],
      isStrict: false
    };
  },
  mounted(){
    let userId = this.$store.getters['security/userId'];
    this.baseConfig = {
        name: 'UserPreference - ' + userId,
        type: 'UserPreference',
        description: 'UserPreference - ' + userId,
        value: {
            userId: userId,
            favourites: []
        }
    };

    this.loadFavourites()
    this.$store.dispatch('security/setNavbarTitle', '');
    this.generateList(this.securityMenu)
  },
  computed: {
    securityMenu(){
      return this.$store.state.security.menu;
    },
    userPreferences(){
      return this.$store.state.security.userPreferences;
    },
    token(){
      return this.$store.state.security.user.token;
    },
    constants(){
        return CommonConstants;
    }
  },
  watch: {
    securityMenu(newValue){
      this.generateList(newValue)
    },
    selectedItem(newValue){
      if(newValue && newValue.to){
        this.$router.push(newValue.to);
      }
    }
  },
  methods: {
    navigate(item){

        this.$router.push(item.href);
    },
    async searchItem(event){
      if (!event.query.trim().length) {
        this.filteredData = [...this.data];
      }else {
        this.filteredData = this.data.filter((item) => {
          return item.label.toLowerCase().includes(event.query.toLowerCase());
        });

        // await genericService.get('search-engine/search?index=.*'+event.query.toUpperCase()+ '.*').then(({data}) => {
        //     if(data.hits.total.value) {
        //       for(let i=0; i<data.hits.hits.length; i++){
        //         let item = data.hits.hits[i];

        //         console.log(item)
        //         this.filteredData.push({
        //             label: item._source.recordType,
        //             to: '/0'
        //           });
        //       }
        //       console.log(this.filteredData)
        //         //*this.filteredData = [...data.hits.hits];
        //     } else {
        //       //this.results = [];
        //     }
        // })
        // CommonService.elasticSearch(event.query.toLowerCase(), resp => {
        //   console.log(resp)
        // })

      }
    },
    loadFavourites: function(){
        let userId = this.$store.getters['security/userId'];
        let data = {
            q: JSON.stringify({
                type: "UserPreference",
                "value.userId": userId
            })
        }
        ConfigurationService.get(data, response => {
            if(response.success && response.data.data && response.data.data.length > 0){
                this.baseConfig = response.data.data[0];
                this.$store.dispatch("security/setUserPreferences", response.data.data[0].value.favourites);
                this.preferencesCreated = true;
            }
        })
    },
    search() {
      if(this.selectedItem) {
        this.$router.push({name: 'search', query: {q: this.selectedItem, strict: this.isStrict}})
      }
    },
    generateList(){
      this.data = [];

      for(let i=0; i<this.securityMenu.length; i++){
        let item = this.securityMenu[i];
        if(item.to){
          this.data.push({
            label: this.$t(item.label),
            to: item.to
          });
        }else{
          let children = item.items;
          for(let k=0; k<children.length; k++){
            let child = children[k];
            if(child.to){
              this.data.push({
                label: this.$t(child.label),
                to: child.to
              });

              this.data.push({
                label: this.$t('create') + ' ' + this.$t(child.label),
                to: child.to + '/0'
              })
            }else{
              let subChildren = child.items;
              for(let j=0; j<subChildren.length; j++){
                let subChild = subChildren[j];

                if(subChild.to){
                  this.data.push({
                    label: this.$t(subChild.label),
                    to: subChild.to
                  });

                  this.data.push({
                    label: this.$t('create') + ' ' + this.$t(subChild.label),
                    to: subChild.to + '/0'
                  })
                }
              }
            }
          }
        }
      }
    },
    parseJwt (token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    }
  }

};

</script>

<style  scoped>


.center{
  margin: 0 auto;
}

.text-center{
  text-align: center;
}
</style>

<template>
  <main>
      <div class="no-header" style="height: 80vh;padding: 5% 0;">
        <!-- <template #content> -->
          
        <p class="text-center"><img src="/layout/images/logo-down-light-gradient.png" style="width: 30%;" /> </p>
        <!-- <p class="text-center" style="font-size: 18px;"><strong>{{$t('welcomeMessage')}}</strong></p> -->
        <p class="text-center" style="font-size: 16px;"><strong>{{$t('testlink1')}} <a :href="constants.TEST_LINK" target="_blank">{{$t('testlinkHere')}}</a></strong></p>
        <p class="text-center">{{$t('homeMessage')}}</p>
        <div class="grid">
          <div class="col-12 lg:col-8 field center">
            <div class="p-inputgroup">
              <AutoComplete class=" w-full-autocomplete" v-model="selectedItem" :suggestions="filteredData" @complete="searchItem($event)" field="label" @keyup.enter="search"/>
              <span class="p-inputgroup-addon hoverable" @click="search()">
                <i class="pi pi-search"></i>
              </span>
              <div class="strict-box">
                <Checkbox
                v-model="isStrict" :binary="true" name="strict" class="strict"/>
                <label for="strict">{{$t('search.strict')}}</label>  
            </div>
          </div>
        </div>
        </div>
        <div class="grid">
          <div class="col-8 field center">
            <div class="grid text-center" style="margin-top:20px">
              <!--<div v-for="item in userPreferences" :key="item.href" class="col-12 md:col-6 lg:col-3" style="cursor:pointer">
                <div class="card widget-feature-box" @click="navigate(item)" v-tooltip="$t(item.title)">
                    <i class="pi pi-file file"></i>
                    <h2>{{$t(item.title)}}</h2>
                </div>
              </div>  -->
               <div class="col-12 md:col-3 mb-3 px-5" v-for="item in userPreferences" :key="item.href" style="cursor:pointer">
                  <span class="p-3 shadow-2 mb-3 inline-block surface-card" style="border-radius: 10px" @click="navigate(item)">
                      <i class="pi pi-desktop text-4xl text-blue-500"></i>
                  </span>
                  <div class="text-900 mb-3 font-medium">{{$t(item.title)}}</div>
                  <span class="text-700 text-sm line-height-3"></span>
              </div>         
            </div>
          </div>
        </div>
        <!-- </template> -->
      </div>
  </main>
</template>

<style scoped>
.favourites {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.strict-box {
  display: flex;
  align-items: center;
}

.strict {
  margin: 0 5px;
}

.file {
  font-size: 30px;
  color: #2196f3
}

.hoverable:hover {
  cursor: pointer;
  transition: 0.3s;
  background-color:darkgray;
  color: whitesmoke;
}

</style>
